import { render } from "./AddUserModal.vue?vue&type=template&id=15b5941e&scoped=true"
import script from "./AddUserModal.vue?vue&type=script&lang=js"
export * from "./AddUserModal.vue?vue&type=script&lang=js"

import "./AddUserModal.vue?vue&type=style&index=0&id=15b5941e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b5941e"]])

export default __exports__